const UIStrategy = require('./ui_strategy');

class UIStrategyUnavailable extends UIStrategy {
    constructor(bookingInfo, view, templates, keys, constants = {}) {
        super(bookingInfo, view, templates, keys, constants);
    }

    getData() {
        const parentData = super.getData();
        return Odigeo._.merge({}, parentData, {});
    }
}

module.exports = UIStrategyUnavailable;
